// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"28":"196a2912","291":"10bee07e","297":"ff7b3970","386":"b125bf4a","446":"d9340a0b","515":"6bff1e1b","540":"b3852c00","579":"5e0f44cd","683":"269e9895","743":"a2092fb3","843":"ab6d363b"}[chunkId] + ".chunk.js";
};